import { SelectField, SelectFieldProps } from './select-field';
import { UsageTypes } from 'api-new/generated';
import { FieldValues } from 'react-hook-form';

type VehicleUsageOption = {
  value: UsageTypes;
  label: string;
};

const VEHICLE_USAGE_OPTIONS: VehicleUsageOption[] = [
  { value: UsageTypes.Private, label: 'Private' },
  { value: UsageTypes.Professional, label: 'Professional' }
];

export type SelectVehicleUsageFieldProps<T extends FieldValues> = Omit<
  SelectFieldProps<T, VehicleUsageOption>,
  'options'
>;

export const SelectVehicleUsageField = <T extends FieldValues>({
  label = 'Vehicle Usage',
  ...props
}: SelectVehicleUsageFieldProps<T>) => {
  return (
    <SelectField<T, VehicleUsageOption>
      {...props}
      label={label}
      options={VEHICLE_USAGE_OPTIONS}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => String(option.value)}
    />
  );
};
